import React, { useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { Container, Row, Col } from "react-bootstrap";
import Buttons from "./Buttons";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";

function PopModal({ show, handleClose }) {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_kkaw7md", "template_e203ddi", form.current, {
        publicKey: "r08KLkIrOA6DHfGZv",
      })
      .then(
        () => {
          console.log("SUCCESS!");
          Swal.fire({
            icon: "success",
            title: "Message Sent!",
            text: "We will get back to you soon.",
          }).then(() => {
            // Reset form and close modal after Swal confirmation
            if (form.current) {
              form.current.reset();
            }
            handleClose(); // Close modal after success
          });
        },
        (error) => {
          console.log("FAILED...", error.text);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong! Please try again.",
          });
        }
      );
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton className="border-0"></Modal.Header>
      <form ref={form} onSubmit={sendEmail}>
        <Modal.Body>
          <Container>
            <Row>
              <Col xs="12" className="w-100">
                <div className="input-container">
                  <input
                    type="text"
                    name="user_name"
                    id="user_name"
                    className="floating-label"
                    required
                  />
                  <label htmlFor="user_name" className="input-label">
                    Name
                  </label>
                </div>
              </Col>
              <Col xs="12" className="w-100">
                <div className="input-container">
                  <input
                    type="text"
                    name="mobile"
                    id="mobile"
                    className="floating-label"
                    required
                  />
                  <label htmlFor="mobile" className="input-label">
                    Mobile No.
                  </label>
                </div>
              </Col>
              <Col xs="12" className="w-100">
                <div className="input-container">
                  <input
                    type="text"
                    name="user_email"
                    id="user_email"
                    className="floating-label"
                    required
                  />
                  <label htmlFor="user_email" className="input-label">
                    Email
                  </label>
                </div>
              </Col>
              <Col xs="12" className="w-100">
                <label htmlFor="message" className="input-label monts-regular">
                  Message
                </label>
                <div className="input-container">
                  <textarea type="text" name="message" id="message" required />
                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            type="submit"
            btnLabel="submit"
            className="get-start"
            // Removed onClick={handleClose} from here
          />
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default PopModal;
